import ClosingCost from './ClosingCost';

export default ClosingCost;